import { POPUP_KEY_RESTORE_PROPERTY } from "../constant";
import { PROPERTIES_URL, postFetchRequest } from "../store/requests";
import i18n from "../i18nService";
import { propertyNamesService } from "./propertyNamesService";
import { propertiesStorage } from "./propertiesStorage";
import {errorCallback, makeUrl} from "../util";

export const propertyRestoreService = {
    restoreItem(itemId, notifyListItem) {
        postFetchRequest(makeUrl([PROPERTIES_URL, itemId, '/?restore=true']), null, notifyListItem, errorCallback, true);
    },
    getItemTitle(itemId, i18nInstance = i18n) {
        const property = propertiesStorage.getById(itemId);
        return propertyNamesService.getLocalization(i18nInstance.resolvedLanguage, property, true, i18nInstance);
    },
    getPopupKey() {
        return POPUP_KEY_RESTORE_PROPERTY;
    },
};
